import React from 'react';
import '../style.css';

const Workflow = () => {
  return (
    <div className="data-analysis-steps" id="Workflow">
      <h2 className="section-heading-center">Our Strategic Approach</h2>
      <h2 className="section-subtitle-center">From insight to implementation</h2>
      <div className="steps-container">
        <div className="single-item">
          <div className="item">
            <div className="info icon" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
              <h4 style={{ marginBottom: '22px', color: '#3366cc' }}><strong>Research</strong></h4>
              <i className="fas fa-search icon" style={{ color: '#3366cc', opacity: '0.9', fontSize: '3rem', marginBottom: '20px' }}></i>
              <p>Analyze market data and identify strategic opportunities.</p>
            </div>
          </div>
        </div>
        <img src="/assets/img/direction-sign.png" alt="Arrow" className="arrow" aria-hidden="true" />
        <div className="single-item">
          <div className="item">
            <div className="info icon" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
              <h4 style={{ marginBottom: '22px', color: '#3366cc' }}><strong>Develop</strong></h4>
              <i className="fas fa-code icon" style={{ color: '#3366cc', opacity: '0.9', fontSize: '3rem', marginBottom: '20px' }}></i>
              <p>Create technically sound solutions with marketing principles built-in.</p>
            </div>
          </div>
        </div>
        <img src="/assets/img/direction-sign.png" alt="Arrow" className="arrow-flipped" aria-hidden="true" />
        <div className="single-item">
          <div className="item">
            <div className="info icon" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
              <h4 style={{ marginBottom: '22px', color: '#3366cc' }}><strong>Measure</strong></h4>
              <i className="fas fa-chart-line icon" style={{ color: '#3366cc', opacity: '0.9', fontSize: '3rem', marginBottom: '20px' }}></i>
              <p>Track key performance indicators and user engagement metrics.</p>
            </div>
          </div>
        </div>
        <img src="/assets/img/direction-sign.png" alt="Arrow" className="arrow" aria-hidden="true" />
        <div className="single-item">
          <div className="item">
            <div className="info icon" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
              <h4 style={{ marginBottom: '22px', color: '#3366cc' }}><strong>Optimize</strong></h4>
              <i className="fas fa-rocket icon" style={{ color: '#3366cc', opacity: '0.9', fontSize: '3rem', marginBottom: '20px' }}></i>
              <p>Fine-tune and enhance based on real-world performance data.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Workflow;